"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DropdownListCategory", {
  enumerable: true,
  get: function get() {
    return _types.Category;
  }
});
Object.defineProperty(exports, "DropdownListProps", {
  enumerable: true,
  get: function get() {
    return _types2.default;
  }
});
Object.defineProperty(exports, "DropdownListItem", {
  enumerable: true,
  get: function get() {
    return _types2.DropdownListItem;
  }
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _propTypes2 = require("./propTypes");

var _schema = _interopRequireDefault(require("./schema"));

var _types = require("../../atoms/OptionsList/types");

var _OptionsList = _interopRequireWildcard(require("../../atoms/OptionsList"));

var _types2 = _interopRequireWildcard(require("./types"));

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function DropdownList(props) {
  var actions = props.actions,
      borderRadius = props.borderRadius,
      containerSelector = props.containerSelector,
      defaultSelectedIds = props.defaultSelectedIds,
      defaultVisible = props.defaultVisible,
      defaultFooter = props.defaultFooter,
      _props$focusOnShowing = props.focusOnShowing,
      focusOnShowing = _props$focusOnShowing === void 0 ? true : _props$focusOnShowing,
      listRef = props.listRef,
      onChange = props.onChange,
      onHide = props.onHide,
      onShow = props.onShow,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      selectedIdsProp = props.selectedIds,
      showArrow = props.showArrow,
      target = props.target,
      visible = props.visible,
      zIndex = props.zIndex,
      PanelComponent = props.PanelComponent,
      maxHeight = props.maxHeight,
      maxWidth = props.maxWidth,
      minWidth = props.minWidth,
      rest = _objectWithoutProperties(props, ["actions", "borderRadius", "containerSelector", "defaultSelectedIds", "defaultVisible", "defaultFooter", "focusOnShowing", "listRef", "onChange", "onHide", "onShow", "placement", "selectedIds", "showArrow", "target", "visible", "zIndex", "PanelComponent", "maxHeight", "maxWidth", "minWidth"]); // Use a ref callback to get more control over re-rendering when a ref is stored.
  // Specifically, the scroll to selected item on first render of dropdown requires this.


  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      containerRef = _useState2[0],
      setContainerRef = _useState2[1];

  var popRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(!!visible),
      _useState4 = _slicedToArray(_useState3, 2),
      showing = _useState4[0],
      setShowing = _useState4[1];

  var _useState5 = (0, _react.useState)(selectedIdsProp),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = (0, _react.useState)(selectedIdsProp),
      _useState8 = _slicedToArray(_useState7, 2),
      saved = _useState8[0],
      setSaved = _useState8[1];
  /**
   * If the visible or selected prop changes, it should always override any locally maintained current value.
   * This allows the component to be controlled.
   */


  (0, _react.useEffect)(function () {
    if (typeof visible === 'boolean' && visible !== showing) {
      setShowing(visible);
    }

    if (typeof selectedIdsProp !== 'undefined' && selectedIdsProp !== selected) {
      setSelected(selectedIdsProp);
    }
  }, [visible, showing, selectedIdsProp, selected]);
  var handleOnHide = (0, _react.useCallback)(function (event) {
    setShowing(false);
    setSelected([]);
    onHide && onHide(event);
    popRef && popRef.current && popRef.current.targetNode && popRef.current.targetNode.focus();
  }, [onHide]);
  var handleOnShow = (0, _react.useCallback)(function (event) {
    setSelected(saved);
    setShowing(true);
    onShow && onShow(event);
  }, [onShow, setSelected, saved]);
  (0, _react.useEffect)(function () {
    if (containerRef && focusOnShowing && showing) {
      (0, _focusWithoutScrolling.default)(containerRef);
    }
  }, [containerRef, focusOnShowing, showing]);

  var setContainerRefFunc = function setContainerRefFunc(el) {
    setContainerRef(el);
  };

  var handleOnChange = (0, _react.useCallback)(function (selection) {
    onChange && onChange(Array.isArray(selection) ? selection : [selection]);
    defaultFooter && setSelected(selection) && setSaved(selection);
  }, [onChange, setSelected, setSaved, defaultFooter]);
  var handleOnApply = (0, _react.useCallback)(function () {
    setSaved(selected);
    popRef && popRef.current && popRef.current.hide();
  }, [setSaved, selected]);

  var handleOnCancel = function handleOnCancel() {
    popRef && popRef.current && popRef.current.hide();
  };

  var handleOnClear = function handleOnClear() {
    setSaved([]);
    setSelected([]);
  };

  var onKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      event.stopPropagation();
    }
  }, []);
  var defaultActions = {
    left: [{
      id: '1',
      text: 'apply',
      onClick: handleOnApply
    }, {
      id: '2',
      text: 'cancel',
      kind: 'secondary',
      onClick: handleOnCancel
    }],
    right: [{
      id: '3',
      text: 'clear',
      variant: 'ghost',
      kind: 'secondary',
      intent: 'danger',
      onClick: handleOnClear
    }]
  };
  var footerActions = defaultFooter ? actions || defaultActions : actions;
  return _react.default.createElement(_Popover.default, {
    borderRadius: borderRadius,
    containerSelector: containerSelector,
    defaultVisible: defaultVisible,
    onHide: handleOnHide,
    onShow: handleOnShow,
    onRequestHide: 'visible' in props ? handleOnHide : undefined,
    placement: placement,
    showArrow: showArrow,
    target: target,
    visible: visible,
    zIndex: zIndex,
    ref: popRef
  }, PanelComponent ? _react.default.createElement(_OptionsList.Container, {
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, _react.default.createElement(PanelComponent, null)) : _react.default.createElement(_Grid.default.Container, null, _react.default.createElement(_Grid.default.Row, null, _react.default.createElement(_OptionsList.default, _extends({
    actions: footerActions,
    defaultSelected: defaultSelectedIds,
    selected: selected,
    onChange: handleOnChange,
    ref: listRef ? (0, _composeReactRefs.default)(listRef, setContainerRefFunc) : setContainerRefFunc,
    onKeyDown: onKeyDown,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, rest)))));
}

DropdownList.displayName = 'DropdownList';
DropdownList.propTypes = _objectSpread({}, _schema.default.propTypes, {
  actions: _propTypes2.footerValidator,
  defaultFooter: _propTypes2.footerValidator,
  target: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(
    /* istanbul ignore next didn't test a non DOM env */
    // @ts-ignore
    _canUseDOM.default ? Element : function Element() {})
  })]).isRequired
});
DropdownList.defaultProps = {
  actions: undefined,
  defaultFooter: false
};
var _default = DropdownList;
exports.default = _default;